import { userAxios } from '../../index'

/**
 * Backoffice del plan Familiar. Permiso membership-family.manage.
 */

/** GET /api/memberships-family/{membership_id} */
const getFamily = async membershipId => {
  const response = await userAxios.get(`memberships-family/${membershipId}`)
  return response.data
}

/** POST /api/memberships-family/{membership_id}/members */
const addMember = async (membershipId, member) => {
  const response = await userAxios.post(`memberships-family/${membershipId}/members`, member)
  return response.data
}

/** DELETE /api/memberships-family/{membership_id}/members/{member} */
const removeMember = async (membershipId, memberMembershipId) => {
  const response = await userAxios.delete(
    `memberships-family/${membershipId}/members/${memberMembershipId}`
  )
  return response.data
}

export default {
  getFamily,
  addMember,
  removeMember,
}
